import React from 'react';

import { Typography } from '@mui/material';

import { MultiFilePreview } from '../../documents/upload/MultiFilePreview';

// ----------------------------------------------------------------------

type FileListProps = {
  files: File[];
  setFiles: (files: File[]) => void;
};

const FileList: React.FC<FileListProps> = ({ files, setFiles }) => {
  const handleRemoveFile = (inputFile: File | string) => {
    setFiles(files.filter((fileFiltered) => fileFiltered !== inputFile));
  };

  if (files.length === 0) {
    return <Typography>no files</Typography>;
  }

  return <MultiFilePreview files={files} onRemove={handleRemoveFile} thumbnail={false} />;
};

export default FileList;
